import { Component, Input, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { Step2 } from '../../../../shared/models/component-messages/diveIN/step2';
import { TypeLieu } from '../models/TypeLieu';

@Component({
  selector: 'app-type-lieu',
  templateUrl: './type-lieu.component.html'
})
export class TypeLieuComponent implements OnInit {

  @Input() uid = '';
  public current_uid = 'TypeLieu';
  @Input() parentForm: FormGroup;
  @Input() errorMessage : string;
	@Input() lieuExecutionLivraison: TypeLieu;
  @Input() disabled: boolean;
  @Input() rule : string;

  public step2 = new Step2();

  constructor() {
  }

  public ngOnInit() {
  }

  public getUid() {
    return this.uid + '_SepSep_' + this.current_uid;
  }

}

